module.exports = __webpack_public_path__ + "img/asset_BTC.b9b87e6f.svg";